export function authOK (userRoles, role) {

    if (role==="ALL" || (role === undefined )) return true;
  
    if (userRoles.indexOf("[FULL_CONFIG]")  !== -1 && role!=='FULL_PARAMS' ) return true
    else {
    if ( Array.isArray(role)) {
        
        let isOk = false ;
        role.forEach(rol => {
           if (userRoles.indexOf("["+rol+"]") !== -1)  isOk = true ;
        })
        return isOk;
    } else return (userRoles.indexOf("["+role+"]") !== -1) ;
    }
  }